function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import { Box, Container, CssBaseline, Toolbar, Typography, AppBar as MuiAppBar, Chip } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { constants, ROUTES } from '../constants';
import { useLocation } from 'react-router-dom';
import { ConfigContext, useSettingsData, usePageImage, useHeaderImage } from './ConfigContext';
import { useThemeDetails } from './ThemeDetailsContext';
import LogoutModal from './LogoutModal';
import { LogoAndProductName } from './LogoAndProductName/LogoAndProductName';
import NotificationModal from './NotificationModal';
import Cookies from 'js-cookie';
import { PermissionGate } from './PermissionGate';
import { RBAC_ACTIONS } from '@/utils/permissionGateConfig';
import { ConfigurationAPI } from '../apis';
var drawerWidth = 240;
var AppBar = styled(MuiAppBar, {
    shouldForwardProp: function shouldForwardProp(prop) {
        return prop !== 'open';
    }
})(function (_ref) {
    var theme = _ref.theme, open = _ref.open;
    return _objectSpread({
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    }, open && {
        marginLeft: drawerWidth,
        width: "calc(100% - ".concat(drawerWidth, "px)"),
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    });
});
// Application navigation is now handled by the ProductSelection page
// Icons and navigation items are no longer needed in the header
export default function MiniDrawer(_ref2) {
    var _configState$settings2, _configState$settings3;
    var children = _ref2.children;
    var theme = useTheme();
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState, setConfigState = _React$useContext.setConfigState;
    var _useState = useState(configState.selectedProduct), _useState2 = _slicedToArray(_useState, 2), application = _useState2[0], setApplication = _useState2[1];
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), userRole = _useState4[0], setUserRole = _useState4[1];
    var _useLocation = useLocation(), pathname = _useLocation.pathname;
    var _useState5 = useState(true), _useState6 = _slicedToArray(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = useState(true), _useState8 = _slicedToArray(_useState7, 2), showHeader = _useState8[0], setShowHeader = _useState8[1];
    var _useState9 = useState(true), _useState0 = _slicedToArray(_useState9, 2), showFooter = _useState0[0], setShowFooter = _useState0[1];
    var _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), clickedIcon = _useState10[0], setClickedIcon = _useState10[1];
    var notificationRef = React.useRef(null);
    var profileRef = React.useRef(null);
    // Cached data hooks
    var getCachedSettings = useSettingsData();
    var getCachedPageImage = usePageImage();
    var getCachedHeaderImage = useHeaderImage();
    var _useThemeDetails = useThemeDetails(), fetchThemeDetails = _useThemeDetails.fetchThemeDetails;
    var getIndicatorBackgroundColor = React.useCallback(function (iconType) {
        var _configState$settings;
        if (clickedIcon !== iconType)
            return 'transparent';
        var isWhiteBackground = (configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.header_background_color) === '#FFFFFF';
        return isWhiteBackground ? '#BB271A' : '#FFFFFF';
    }, [clickedIcon, configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.header_background_color]);
    var renderIndicator = function renderIndicator(ref, iconType) {
        if (!ref.current)
            return null;
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                position: 'absolute',
                bottom: 0,
                left: ref.current.offsetLeft,
                width: '32px',
                height: '3px',
                backgroundColor: getIndicatorBackgroundColor(iconType),
                transition: 'background-color 0.3s ease',
                borderRadius: '2px 2px 0 0'
            }
        });
    };
    useEffect(function () {
        var handleNotificationModalOpen = function handleNotificationModalOpen() {
            return setClickedIcon('notification');
        };
        var handleNotificationModalClose = function handleNotificationModalClose() {
            return setClickedIcon(null);
        };
        var handleProfileModalOpen = function handleProfileModalOpen() {
            return setClickedIcon('profile');
        };
        var handleProfileModalClose = function handleProfileModalClose() {
            return setClickedIcon(null);
        };
        globalThis.window.addEventListener('notificationModalOpen', handleNotificationModalOpen);
        globalThis.window.addEventListener('notificationModalClose', handleNotificationModalClose);
        globalThis.window.addEventListener('profileModalOpen', handleProfileModalOpen);
        globalThis.window.addEventListener('profileModalClose', handleProfileModalClose);
        return function () {
            globalThis.window.removeEventListener('notificationModalOpen', handleNotificationModalOpen);
            globalThis.window.removeEventListener('notificationModalClose', handleNotificationModalClose);
            globalThis.window.removeEventListener('profileModalOpen', handleProfileModalOpen);
            globalThis.window.removeEventListener('profileModalClose', handleProfileModalClose);
        };
    }, []);
    useEffect(function () {
        var _roleObject$;
        var roleObject = undefined;
        try {
            var _sessionStorage$getIt;
            roleObject = JSON.parse((_sessionStorage$getIt = sessionStorage.getItem('policy')) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : '{}');
        }
        catch (_unused) {
            // Session storage parse error, use undefined
        }
        var userRole = roleObject ? (_roleObject$ = roleObject[0]) === null || _roleObject$ === void 0 ? void 0 : _roleObject$.name : null;
        setUserRole(userRole);
        setApplication(configState === null || configState === void 0 ? void 0 : configState.selectedProduct);
    }, [configState === null || configState === void 0 ? void 0 : configState.selectedProduct]);
    useEffect(function () {
        var fetchData = /*#__PURE__*/ function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                var _t;
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.p = _context.n) {
                            case 0:
                                _context.p = 0;
                                _context.n = 1;
                                return Promise.all([getSettings(), getPageImage(), getHeaderImage(), getLayoutConfig(), fetchThemeDetails()]);
                            case 1:
                                _context.n = 3;
                                break;
                            case 2:
                                _context.p = 2;
                                _t = _context.v;
                                console.error('Failed to load initial layout data:', _t);
                            case 3:
                                _context.p = 3;
                                setIsLoading(false);
                                return _context.f(3);
                            case 4:
                                return _context.a(2);
                        }
                }, _callee, null, [[0, 2, 3, 4]]);
            }));
            return function fetchData() {
                return _ref3.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    var getSettings = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            var response;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return getCachedSettings();
                        case 1:
                            response = _context2.v;
                            setConfigState(function (prevState) {
                                return _objectSpread(_objectSpread({}, prevState), {}, {
                                    settings: _objectSpread(_objectSpread({}, prevState.settings), response)
                                });
                            });
                        case 2:
                            return _context2.a(2);
                    }
            }, _callee2);
        }));
        return function getSettings() {
            return _ref4.apply(this, arguments);
        };
    }();
    var getPageImage = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var response;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            _context3.n = 1;
                            return getCachedPageImage();
                        case 1:
                            response = _context3.v;
                            setConfigState(function (prevState) {
                                return _objectSpread(_objectSpread({}, prevState), {}, {
                                    settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                        page_image: response
                                    })
                                });
                            });
                        case 2:
                            return _context3.a(2);
                    }
            }, _callee3);
        }));
        return function getPageImage() {
            return _ref5.apply(this, arguments);
        };
    }();
    var getHeaderImage = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            var response;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            _context4.n = 1;
                            return getCachedHeaderImage();
                        case 1:
                            response = _context4.v;
                            setConfigState(function (prevState) {
                                return _objectSpread(_objectSpread({}, prevState), {}, {
                                    settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                        header_logo_image: response
                                    })
                                });
                            });
                        case 2:
                            return _context4.a(2);
                    }
            }, _callee4);
        }));
        return function getHeaderImage() {
            return _ref6.apply(this, arguments);
        };
    }();
    var getLayoutConfig = /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var bundle, _iterator, _step, config, _iterator2, _step2, item, _t2;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.p = _context5.n) {
                        case 0:
                            _context5.p = 0;
                            _context5.n = 1;
                            return ConfigurationAPI.getConfigurations('UserExperience');
                        case 1:
                            bundle = _context5.v;
                            _iterator = _createForOfIteratorHelper(bundle.resource || []);
                            try {
                                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                    config = _step.value;
                                    _iterator2 = _createForOfIteratorHelper(config.items || []);
                                    try {
                                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                            item = _step2.value;
                                            if (item.key === 'RBAC_UI_HEADER') {
                                                setShowHeader(item.value !== false);
                                            }
                                            if (item.key === 'RBAC_UI_FOOTER') {
                                                setShowFooter(item.value !== false);
                                            }
                                        }
                                    }
                                    catch (err) {
                                        _iterator2.e(err);
                                    }
                                    finally {
                                        _iterator2.f();
                                    }
                                }
                            }
                            catch (err) {
                                _iterator.e(err);
                            }
                            finally {
                                _iterator.f();
                            }
                            _context5.n = 3;
                            break;
                        case 2:
                            _context5.p = 2;
                            _t2 = _context5.v;
                        case 3:
                            return _context5.a(2);
                    }
            }, _callee5, null, [[0, 2]]);
        }));
        return function getLayoutConfig() {
            return _ref7.apply(this, arguments);
        };
    }();
    useEffect(function () {
        if ((configState === null || configState === void 0 ? void 0 : configState.selectedProduct) === '') {
            // Get product from cookie or URL
            var productFromCookie = Cookies.get('Product Selected');
            if (productFromCookie) {
                setApplication(productFromCookie);
            }
            else {
                var pathParts = pathname.split('/').filter(Boolean);
                if (pathParts.length > 0) {
                    setApplication(pathParts[0]);
                }
            }
        }
        else {
            setApplication(configState === null || configState === void 0 ? void 0 : configState.selectedProduct);
        }
    }, [configState === null || configState === void 0 ? void 0 : configState.selectedProduct, pathname]);
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(CssBaseline, null), showHeader && !isLoading && pathname != '/' && application != '' ? /*#__PURE__*/ React.createElement(AppBar, {
        position: "fixed",
        sx: {
            background: "".concat(configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.header_background_color),
            borderBottom: '1px solid #EBEBEB',
            zIndex: 1200,
            boxShadow: 'none',
            height: 64,
            overflow: 'visible'
        }
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        sx: {
            padding: '20px !important',
            minHeight: '64px !important',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(LogoAndProductName, null), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    }, application === 'associateProductivity' && /*#__PURE__*/ React.createElement(Chip, {
        label: userRole,
        sx: {
            backgroundColor: '#37474f',
            marginRight: '16px',
            color: '#ffffff',
            fontFamily: 'Open Sans',
            fontSize: '13px',
            fontWeight: '400',
            height: '24px'
        }
    }), application === 'inventory' && /*#__PURE__*/ React.createElement(Chip, {
        label: "Inventory Manager",
        sx: {
            backgroundColor: '#fff',
            border: '1px solid #d9d9d9',
            marginRight: '12px',
            color: '#000',
            fontFamily: 'Open Sans',
            fontSize: '12px',
            fontWeight: '600',
            height: '24px'
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            gap: 2,
            pr: 2
        }
    }, /*#__PURE__*/ React.createElement(PermissionGate, {
        action: [RBAC_ACTIONS.RBAC_VIEW_NOTIFICATION]
    }, /*#__PURE__*/ React.createElement(Box, {
        ref: notificationRef
    }, /*#__PURE__*/ React.createElement(NotificationModal, null))), /*#__PURE__*/ React.createElement(Box, {
        ref: profileRef
    }, /*#__PURE__*/ React.createElement(LogoutModal, null))))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '3px',
            pointerEvents: 'none'
        }
    }, renderIndicator(notificationRef, 'notification'), renderIndicator(profileRef, 'profile'))) : null, !isLoading && /*#__PURE__*/ React.createElement(Box, {
        component: "main",
        sx: {
            flexGrow: 1,
            pb: 0,
            marginTop: showHeader && pathname != '/' && application != '' ? '64px' : '0px',
            marginLeft: 0,
            width: '100%',
            height: showHeader && pathname != '/' && application != '' ? 'calc(100vh - 64px)' : '100vh',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        }
    }, !isLoading && /*#__PURE__*/ React.createElement(Container, {
        maxWidth: false,
        disableGutters: true,
        sx: {
            backgroundColor: theme.palette.background["default"],
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
        },
        role: "container-parent"
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1
        }
    }, children), !isLoading && showFooter && /*#__PURE__*/ React.createElement(Box, {
        component: "footer",
        sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#F8F8F8',
            width: '100%',
            padding: '16px',
            marginTop: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Typography, null, /*#__PURE__*/ React.createElement(Box, {
        component: "span",
        sx: {
            fontSize: '16px',
            fontWeight: '700'
        }
    }, constants.Copyright_text4), ' | ' + constants.Copyright_text1 + new Date().getFullYear() + constants.Copyright_text2), "\xA0\xA0\xA0\xA0", /*#__PURE__*/ React.createElement("a", {
        href: process.env.REACT_APP_https://cookienotice.deloitte.com,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            textDecoration: 'none',
            color: 'inherit'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    }, constants.privacy)), "\xA0\xA0\xA0\xA0", /*#__PURE__*/ React.createElement("a", {
        href: ROUTES.TERMS_OF_USE,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            textDecoration: 'none',
            color: 'inherit'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    }, constants.terms_of_use))))));
}
